import FirstTopGoalscorer from './FirstTopGoalscorer';
import NextTopGoalscorer from './NextTopGoalscorer';
import { MAX_TOPSCORERS } from './TopGoalscorers.constants';
import type { TeamTopGoalscorersProps } from './TopGoalscorers.types';

export default function TeamTopGoalscorers(props: TeamTopGoalscorersProps) {
  const { jerseySrc, topGoalscorers, isAway = false } = props;

  return (
    <div className="flex flex-col gap-2">
      <FirstTopGoalscorer jerseySrc={jerseySrc} topGoalscorer={topGoalscorers[0]} isAway={isAway} />

      {topGoalscorers.slice(1, MAX_TOPSCORERS).map((topGoalscorer) => {
        if (topGoalscorer.goals === 0) {
          return null;
        }

        return (
          <NextTopGoalscorer
            key={`${topGoalscorer.name}-${topGoalscorer.position}-${topGoalscorer.goals}`}
            jerseySrc={jerseySrc}
            topGoalscorer={topGoalscorer}
            isAway={isAway}
          />
        );
      })}
    </div>
  );
}
